import { TeamOutlined } from "@ant-design/icons"
import { Select, type SelectProps } from "components/Select/Select"
import { Team } from "interface/user"
import { memo, useMemo } from "react"
import { useAdminTeams } from "services/teams"

export const SelectTeams = memo(function SelectTeams<T = Team["id"]>({
	hiddenTeams = [],
	value,
	...props
}: SelectProps<T> & { hiddenTeams?: Team["id"][] }) {
	const { data = [], isFetching } = useAdminTeams()
	const options = useMemo(
		() =>
			data
				.filter(({ id }) => {
					const noTeamsToHide = !hiddenTeams.includes(id)
					return noTeamsToHide || id === value
				})
				.map(({ id, name }) => ({
					value: id,
					label: name,
				})),
		[data, hiddenTeams, value],
	)

	return (
		<Select<T>
			{...props}
			value={value}
			loading={isFetching}
			virtual={false}
			showSearch={{ optionFilterProp: "label" }}
			options={options}
			prefix={<TeamOutlined aria-hidden />}
		/>
	)
}) as <T = Team["id"]>(
	props: SelectProps<T> & { hiddenTeams?: Team["id"][] },
) => React.ReactNode
